// Fork: branded header shared by every public status page.
import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useStatusHref, type StatusBranding } from './statusShared'

export function StatusHeader({ branding, orgName, children }: {
  branding?: StatusBranding
  orgName?: string
  children?: ReactNode
}) {
  const href = useStatusHref()
  const accentColor = branding?.accent_color || '#2563eb'
  return (
    <div className="bg-white border-b border-t-4 border-gray-200" style={{ borderTopColor: accentColor }}>
      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-5">
        <div className="flex items-center justify-between gap-4">
          <Link to={href('/')} className="min-w-0 flex items-center gap-3 hover:opacity-90">
            {branding?.logo_url && (
              <img
                src={branding.logo_url}
                alt=""
                className="h-10 w-auto max-w-[40%] flex-shrink-0 object-contain"
                referrerPolicy="no-referrer"
              />
            )}
            <h1 className="text-2xl font-bold text-gray-900 break-words min-w-0">
              {branding?.title || `${orgName || 'System'}`}
            </h1>
          </Link>
          {children}
        </div>
      </div>
    </div>
  )
}
